import type { FC } from 'react'
import { useState } from 'react'

import { Container } from '@skytech/ui/Container'
import { useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import { useAppContext } from '@/app/index.context'
import { Translation } from '@/app/translations/Translation'
import SystemMessage from '@/components/SystemMessage'
import { commonQueries } from '@/resources/queries'
import { commonSystemMessagesResources } from '@/resources/system-messages'

import './index.styles.scss'

dayjs.extend(relativeTime)

const SystemMessages: FC = () => {
  const { locale } = useAppContext()
  const readSystemMessages = localStorage.getItem('read-system-messages')
  const seenMessagedInitial = readSystemMessages ? JSON.parse(readSystemMessages) : undefined

  const [seenMessages, setSeenMessages] = useState<number[] | undefined>(seenMessagedInitial)

  const { data } = useQuery(commonQueries.systemMessages(), commonSystemMessagesResources.getList)

  const messageList = data?.filter(message => message.locale === locale) || []

  return (
    <Container className="all-system-messages-page">
      <Container.Header>
        <Translation id="Notifications" />
      </Container.Header>

      {messageList.map(message => (
        <div key={message.id} className="system-message-tile">
          <SystemMessage
            maxTextHeight={99999}
            seenMessages={seenMessages}
            {...message}
            onSeenMessagesSet={setSeenMessages}
          />

          <div className="divider" />
        </div>
      ))}
    </Container>
  )
}

export default SystemMessages
